import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React from 'react';
import IconChevronDown from '../../resources/icons/IconChevronDown.svg';
export var SingleSelect = function SingleSelect(_ref) {
  var setFilterDropdownState = _ref.setFilterDropdownState,
    setFilterChoiceState = _ref.setFilterChoiceState,
    resetFilterChoiceState = _ref.resetFilterChoiceState,
    items = _ref.items,
    filters = _ref.filters,
    isOpen = _ref.isOpen,
    label = _ref.label,
    filterName = _ref.filterName,
    resultsAmount = _ref.resultsAmount,
    clearAllLabel = _ref.clearAllLabel,
    showNResultsLabel = _ref.showNResultsLabel;
  var _React$useState = React.useState({}),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    currentState = _React$useState2[0],
    setCurrentState = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    slectedValue = _React$useState4[0],
    setSlectedValue = _React$useState4[1];
  React.useEffect(function () {
    var cur = {};
    Object.keys(items).forEach(function (key) {
      var selected = filters.includes(key);
      cur[key] = selected;
      selected && setSlectedValue(key);
    });
    setCurrentState(cur);
  }, [items, filters]);
  var toggleFilter = function toggleFilter(e) {
    setFilterDropdownState(!isOpen, filterName);
    e.preventDefault();
  };
  var sendFilter = function sendFilter(e) {
    setFilterChoiceState(true, slectedValue, filterName, true);
    setFilterDropdownState(!isOpen, filterName);
    e.preventDefault();
  };
  var clearFilter = function clearFilter(e) {
    resetFilterChoiceState(filterName);
    e.preventDefault();
  };
  var itemToggle = function itemToggle(value) {
    setSlectedValue(value);
    setCurrentState(function (prev) {
      for (var prevKey in prev) {
        if (value === prevKey) {
          prev[value] = true;
        } else {
          prev[prevKey] = false;
        }
      }
      return prev;
    });
  };

  // If you check some facet - recalculate amount of results to be shown.
  var amountToBeShown = filters.length ? Object.keys(items).reduce(function (amount, key) {
    if (filters.includes(key)) {
      return amount + items[key];
    }
    return amount;
  }, 0) : resultsAmount;
  return /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-panel eloqua ".concat(isOpen ? 'filter-panel--open' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "body-small filter-panel__mob-label"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__box ".concat(isOpen ? 'filter-panel__box--openedDrop' : '')
  }, /*#__PURE__*/React.createElement("a", {
    className: "filter-panel__trigger js-filter-panel__trigger",
    href: "/#",
    onClick: toggleFilter,
    "aria-label": "Filter Name",
    "aria-labelledby": "Filter Name"
  }, label || filterName), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__text body-small"
  }, filters && filters.length ? filters.join(',') : label || filterName), /*#__PURE__*/React.createElement("img", {
    className: "icon",
    src: IconChevronDown,
    alt: "Expand down",
    "aria-disabled": true
  })), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner-scroll"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fp__inner-cb"
  }, /*#__PURE__*/React.createElement("a", {
    className: "body-medium fp__inner-clear",
    href: "/#",
    onClick: clearFilter,
    "aria-label": "Clear All",
    "aria-labelledby": "Clear All"
  }, clearAllLabel)), Object.keys(items).map(function (key) {
    return /*#__PURE__*/React.createElement("label", {
      className: "checkbox-aligned fp__inner-label",
      htmlFor: key.replace(/\s/g, '_'),
      key: key
    }, /*#__PURE__*/React.createElement("input", {
      checked: currentState[key],
      className: "input-choice input-single fp__radio",
      type: "radio",
      name: filterName,
      value: key,
      id: key.replace(/\s/g, '_'),
      onChange: function onChange() {
        return itemToggle(key);
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "fp__inner-label-text"
    }, key, " (", items[key], ")"), /*#__PURE__*/React.createElement("span", {
      className: "fp__inner-label-bg"
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__bottom "
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary js-btn-close-panel",
    onClick: sendFilter
  }, showNResultsLabel.replace('{#resultsAmount#}', '')))))));
};
export default SingleSelect;